import React from "react";
import ReactDOM from "react-dom";
import { Provider, useDispatch, TypedUseSelectorHook, useSelector } from "react-redux";
import { tz } from "moment-timezone";

import { AnyAction, configureStore, ThunkAction } from "@reduxjs/toolkit";
import App from "./App";
import "./index.less";
import rootReducer from "./store/reducers/rootReducer";

export const store = configureStore({
  reducer: rootReducer,
});

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();

export type RootState = ReturnType<typeof store.getState>;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// Универсальный тип для аргумента dispatch
export type Dispatchable = AnyAction | ThunkAction<Promise<any>, RootState, unknown, AnyAction>;

tz.setDefault(localStorage.getItem("timezoneName") || undefined);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
